export default __webpack_public_path__ + "static/media/moans.8c606f0c.mp3";